// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-box[data-v-3921e050]{background:#e8e8eb}.brand-logo[data-v-3921e050]{max-height:40px}.mfg2020[data-v-3921e050]{height:250px}.image-content[data-v-3921e050]{font-size:0}.brand-logo[data-v-3921e050]{height:40px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
